import { SectionDto } from "./section-dto";

export class AreaDto {
  sections: SectionDto[] = [];
}
